import { render, staticRenderFns } from "./CrewCountsAverageCard.vue?vue&type=template&id=f502431c&scoped=true&"
import script from "./CrewCountsAverageCard.vue?vue&type=script&lang=ts&"
export * from "./CrewCountsAverageCard.vue?vue&type=script&lang=ts&"
import style0 from "./CrewCountsAverageCard.vue?vue&type=style&index=0&id=f502431c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f502431c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSelect,VSpacer})
